import React, { useContext } from 'react'
import { Columns, CustomButton, Info, launchToast, Link, ToastTypes } from '../../components'
import { WemoloLoading, WemoloTypography } from '../../components/Wemolo'
import { StationContext } from './StationContext'
import { getPillFromDeviceType } from '../../data/enums'
import styles from './StationInfo.module.css'

export const StationInfo = () => {
    const stationContext = useContext(StationContext)
    const renderStations = () => {
        if (!stationContext.selectedStationDeviceStations) {
            return '-'
        }

        const filteredStations = stationContext.selectedStationDeviceStations.filter(
            (station) => station.station_name !== stationContext.selectedStationData?.station_name
        )

        if (filteredStations.length === 0) {
            return '-'
        }

        return filteredStations.map((station) => (
            <React.Fragment key={station.station_name}>
                <span>
                    <Link link={`?stationName=${station.station_name}`} target="_self" text={station.station_name} />
                    &nbsp; &nbsp; &nbsp; &nbsp;
                </span>
            </React.Fragment>
        ))
    }
    const renderOtherStationsInLot = () => {
        if (!stationContext.stationsInLot) {
            return '-'
        }

        const filteredStations = stationContext.stationsInLot?.station.sort((a, b) => {
            const partsA = a.station_name.split('_')
            const partsB = b.station_name.split('_')

            const numberA = parseInt(partsA[1], 10)
            const numberB = parseInt(partsB[1], 10)

            const suffixA = partsA[2]
            const suffixB = partsB[2]

            if (suffixA !== suffixB) {
                return suffixA.localeCompare(suffixB)
            }
            return numberA - numberB
        })

        if (filteredStations.length === 0) {
            return '-'
        }

        return filteredStations.map((station, index) => {
            if (station.station_name === stationContext.selectedStationData?.station_name) {
                return <span key={index}>{station.station_name} &nbsp; &nbsp; &nbsp; &nbsp;</span>
            }

            return (
                <React.Fragment key={station.station_name}>
                    <span>
                        <Link
                            link={`?stationName=${station.station_name}`}
                            target="_self"
                            text={station.station_name}
                        />
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                </React.Fragment>
            )
        })
    }

    const stationNameFromStationName = stationContext.selectedStationData?.station_name?.split('_')
    const lotNameFromLotSectionID = stationContext.selectedStationData?.lot_section_id?.split('_')

    const firstElementFromStationName = stationNameFromStationName?.[0]
    const firstElementFromLotSectionID = lotNameFromLotSectionID?.[0]

    const errorInLotName = firstElementFromStationName !== firstElementFromLotSectionID

    // On a cold start with `?stationName=` in the URL, the selection can't resolve until the station
    // list lands — without this every field reads as "-", as if the station had no data.
    if (stationContext.loadingStations || stationContext.loadingStationData) {
        return (
            <div className={styles.loading}>
                <WemoloLoading />
            </div>
        )
    }

    return (
        <div className={styles.root}>
            <div className={styles.row}>
                <div className={styles.col}>
                    <Columns>
                        <Info
                            copyValue={true}
                            label="Parking lot"
                            copyValueString={firstElementFromLotSectionID}
                            value={
                                <Link
                                    link={`/lot?lot=${firstElementFromLotSectionID}`}
                                    target="_self"
                                    text={firstElementFromLotSectionID}
                                />
                            }
                        />
                        {errorInLotName && <div className={styles.error}>Parking lot name mismatch</div>}
                        <Info
                            copyValue={true}
                            copyValueString={stationContext?.info.deviceName}
                            label="Device Name"
                            value={
                                stationContext?.info.deviceName ? (
                                    <Link
                                        link={`/device?deviceId=${stationContext.selectedStationData?.device_uuid}`}
                                        target="_self"
                                        text={stationContext?.info.deviceName || '-'}
                                    />
                                ) : (
                                    '-'
                                )
                            }
                        />
                        <Info
                            copyValue={false}
                            label="Station Type"
                            value={
                                <WemoloTypography variant="title-xsmall" tag="span" className={styles.pillText}>
                                    {getPillFromDeviceType(stationContext.selectedStationData?.type) || '-'}
                                </WemoloTypography>
                            }
                        />

                        <Info
                            copyValue={true}
                            label="Device UUID"
                            value={stationContext.selectedStationData?.device_uuid || '-'}
                        />
                        <Info label="Other Stations In Parking Lot" value={<div>{renderOtherStationsInLot()}</div>} />

                        <Info label="Other Stations linked to device" value={<div>{renderStations()}</div>} />
                    </Columns>
                </div>

                <Columns
                    extraStyles={{
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        flex: '50%'
                    }}
                >
                    <CustomButton
                        onClick={() => {
                            navigator.clipboard.writeText(stationContext?.selectedStation?.station_name || 'test')
                            launchToast(ToastTypes.Success, 'Copied  Station name to clipboard')
                            window.open(
                                `https://airtable.com/appOprM6GwkxZ9CR1/tblFpGJkyqXZnmhbc/viwqmV1JdCAbYAtwj?blocks=hide`
                            )
                        }}
                        extraProps={{ minWidth: '270px !important;' }}
                    >
                        Go to Airtable
                    </CustomButton>
                </Columns>
            </div>
        </div>
    )
}
